import { RichTextFieldProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

// for when a certain style needs to be applied to all variants of a RichTextField
export const applyToAllRTFVariants = (
  className: string
): Required<RichTextFieldProps['classNames']> => {
  return {
    paragraph: className,
    listOrdered: className,
    listUnordered: className,
    quote: className,
    bold: className,
    image: className,
    code: { root: className },
    heading: {
      h1: { root: className },
      h2: { root: className },
      h3: { root: className },
      h4: { root: className },
      h5: { root: className },
      h6: { root: className },
      xl: { root: className },
      l: { root: className },
    },
    link: { root: className },
  };
};
